import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './screens/Dashboard/Dashboard';
import Login from './screens/Login/Login';
import NotFound from './components/NotFound/NotFound';
import Roles from './screens/Roles/Roles';
import Users from './screens/Users/Users';
import Storage from './screens/Server/Server';
import Profile from './screens/Profile/Profile';
import Changepassword from './screens/ChangePassword/ChangePassword';
import Categories from './screens/Categories/Categories';
import Keywords from './screens/Categories/Keywords/Keywords';
import ForgotPassword from './screens/ForgotPassword/ForgotPassword/ForgotPassword';
import ResetPassword from './screens/ForgotPassword/ResetPassword/ResetPassword';
import TwoFaAuth from './screens/TwoFa-auth/TwoFaAuth';
import Organization from './screens/Organization/Organization';
import OrganizationSettings from './screens/Organization/OrganizationSettings';
import UsersDetails from './screens/Users/UsersDetails';
import UsersActivity from './screens/Users/UsersActivity';
import CategoryDetails from './screens/Categories/CategoryDetails';
import NoiseWords from './screens/NoiseWords/NoiseWords';
import Layout from './components/Layout/Layout';
import ActivityIndicator from './components/ActivityIndicator/ActivityIndicator';
import StorageDetails from './screens/Server/ServerDetails';
import ApplicationLogDetails from './screens/Server/ApplicationLogDetails';
import RolesDetails from './screens/Roles/RolesDetails';
import PrivateRoutes from './components/PrivateRoutes/PrivateRoutes';
import WebsiteDetailsAdmin from './screens/Websites/WebsiteDetailsAdmin';
import WebsiteDetailsSupAdmin from './screens/Websites/WebsiteDetailsSupAdmin';
import NoiseWordsDetails from './screens/NoiseWords/NoiseWordsDetails';
import CategoryLabel from './screens/Categories/CategoryLabel';
import WebsitesSuperAdmin from './screens/Websites/WebsitesSuperAdmin';
import WebsitesAdmin from './screens/Websites/WebsitesAdmin';
import WebisiteReview from './screens/Websites/WebsiteReview/WebisiteReview';
import Bulkupload from './screens/Categories/Keywords/Bulkupload';
import EmailVerification from './screens/ForgotPassword/EmailVerification/EmailVerification';
import CheckMail from './screens/ForgotPassword/EmailVerification/CheckMail';
import CrawlJobs from './screens/CrawlJobs/CrawlJobs';
import HitCountJobs from './screens/HitCountJobs/HitCountJobs';
import CrawlJobsView from './screens/CrawlJobs/CrawlJobsView';
import HitCountJobView from './screens/HitCountJobs/HitCountJobView';
import DMCAFiles from './screens/DMCAFiles/DMCAFiles';
import DMCAFilesView from './screens/DMCAFiles/DMCAFilesView';
import ManualSearch from './screens/ManualSearch/ManualSearch';
import Reports from './screens/Reports/Reports';
import Test from './screens/Test';

const Router = () => {
  return (
    <BrowserRouter
      basename={
        process.env.NODE_ENV === 'development'
          ? '/'
          : process.env.REACT_APP_SUBDIRECTORY
      }
    >
      <Suspense fallback={<ActivityIndicator />}>
        <Routes>
          <Route element={<PrivateRoutes />}>
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/roles" element={<Roles />} />
              <Route path="/users" element={<Users />} />
              <Route path="/userDetails/:id" element={<UsersDetails />} />
              <Route path="/userActivity/:id" element={<UsersActivity />} />

              <Route path="/websitesSuper" element={<WebsitesSuperAdmin />} />
              <Route path="/websiteAdmin" element={<WebsitesAdmin />} />
              <Route path="/websiteDetail/:id" element={<WebsiteDetailsAdmin />} />
              <Route path="/websiteReview/:id" element={<WebisiteReview />} />
              <Route
                path="/websiteDetails/:id"
                element={<WebsiteDetailsSupAdmin />}
              />
              <Route
                path="/websiteReview/:siteOrganizationIndexId/:siteOrganizationId"
                element={<WebisiteReview />}
              />
              <Route path="/crawljobs" element={<CrawlJobs />} />
              <Route path="/crawlView/:id" element={<CrawlJobsView />} />
              <Route path="/hitCountJobs" element={<HitCountJobs />} />
              <Route path="/hitCountView/:id" element={<HitCountJobView />} />
              <Route path="/roleDetails/:id" element={<RolesDetails />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/categoryDetails/:id" element={<CategoryDetails />} />
              <Route path="/categoryLabel" element={<CategoryLabel />} />
              <Route path="/keywords" element={<Keywords />} />
              <Route path="/bulkUpload" element={<Bulkupload />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/changepassword" element={<Changepassword />} />
              <Route path="/server" element={<Storage />} />
              <Route path="/serverDetails/:id" element={<StorageDetails />} />
              <Route
                path="/logDetails/:fileName"
                element={<ApplicationLogDetails />}
              />
              <Route path="/organization" element={<Organization />} />
              <Route
                path="/organizationSettings/:id"
                element={<OrganizationSettings />}
              />
              <Route path="/dmcaFiles" element={<DMCAFiles />} />
              <Route path="/dmcaFilesView/:id/:userId" element={<DMCAFilesView />} />
              <Route path="/noiseWords" element={<NoiseWords />} />
              <Route path="/noiseWordDetails/:id" element={<NoiseWordsDetails />} />
              <Route path="/manualSearch" element={<ManualSearch />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/test" element={<Test />} />

              <Route path="*" element={<NotFound />} />
            </Route>
          </Route>
          <Route path="/" element={<Login />} />
          <Route path="/forgotPassword" element={<ForgotPassword />} />
          <Route path="/resetPassword" element={<ResetPassword />} />
          <Route path="/emailVerification/" element={<EmailVerification />} />
          <Route path="/checkmail/:email" element={<CheckMail />} />

          <Route
            path="/twofactorAuthorization/:rememberMe"
            element={<TwoFaAuth />}
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Router;
